export const utilityMutations = {
    SET(state, [variable, value]) {
        state[variable] = value;
    }
}